import getOrderFormMarkupWithData from '../api/getOrderFormMarkupWithData';
import {always, apply, assoc, equals, forEach, map as Rmap, pipe, prop, reduce, when} from 'ramda';
import {initFormControls} from '../bootstrap/initFormControls';
import {closeWait, showWait} from '../libs/bx-custom-loader';
import {console, getElementById, querySelectorAll, replaceWith, toHTML} from '../dom-utils';
import '../polyfills/Sale.OrderAjaxComponent';
import {first, fromEvent, map, mergeMap, share, Subject} from 'rxjs';

const trueOrUndefined = when(equals(false), always(undefined));
const propErrors = prop('errors');
const {error: printError} = console;
const toError = ({message, code}) => new Error(message, {cause: code});
const toErrors = map(toError);
const printErrors = forEach(printError);
const printResponseErrors = pipe(
    propErrors,
    toErrors,
    printErrors
);

const getCompatableResult = (form) => {
    const PERSON_TYPE = reduce(
        (acc, node) => assoc(node.value, {
            CHECKED: node.checked,
            ID: node.value,
        }, acc),
        {},
        querySelectorAll('[name="person_type_id"]', form)
    );

    const DELIVERY = Rmap((item) => ({
        CHECKED: trueOrUndefined(item.checked),
        ID: item.value,
    }), querySelectorAll('[name="delivery_id"]'), form);

    const result = {
        order: {
            PERSON_TYPE,
            DELIVERY,
        },
    };

    return result;
};

const rerenderOrderComponent = (context, data) => {
    const html = toHTML(data);

    replaceWith(html, context);

    return html;
}

const listenFormControlsForChange = (controlsSelector) => mergeMap((componentElements) => {
    const [_, formElement] = componentElements;
    const controls = querySelectorAll(controlsSelector, formElement);

    return fromEvent(controls, 'change').pipe(
        first(),
        map(() => componentElements)
    );
})

/**
 *
 * @param {HTMLElement} updatableElement
 * @param {HTMLElement} formToBeSend
 * @param {string} selectorTriggerElements
 */
export default function createOrderForm(updatableElement, formToBeSend, selectorTriggerElements) {
    if (!updatableElement || !formToBeSend) return;

    const {id: componentId} = updatableElement;
    const {id: formId} = formToBeSend;

    const component$ = new Subject();
    const ajaxResult = new Subject();

    const ajaxResult$ = ajaxResult.pipe(share());
    const form$ = component$.pipe(share());
    const formUpdates$ = form$.pipe(
        listenFormControlsForChange(selectorTriggerElements),
    );

    const updateOrderComponent = (componentElement, form) => {
        showWait(componentElement);

        return getOrderFormMarkupWithData(new FormData(form))
            .then(({data}) => {
                rerenderOrderComponent(componentElement, data);

                const component = getElementById(componentId);
                const form = getElementById(formId);
                const result = getCompatableResult(form);

                ajaxResult.next(result);

                closeWait(componentElement);
                component$.next([component, form]);

                return [component, form];
            })
            .catch(printResponseErrors);
    }

    formUpdates$.subscribe(apply(updateOrderComponent));

    component$.next([updatableElement, formToBeSend]);

    ajaxResult$.subscribe((result) => BX.onCustomEvent('OnAjaxSuccess', [result]));

    return ajaxResult$;
}
